import { jsx as f } from "react/jsx-runtime";
import { c as l } from "react/compiler-runtime";
import { Tab as m } from "@mui/material";
function a(i) {
  const r = l(6);
  let e, o;
  r[0] !== i ? ({
    children: e,
    ...o
  } = i, r[0] = i, r[1] = e, r[2] = o) : (e = r[1], o = r[2]);
  let t;
  return r[3] !== e || r[4] !== o ? (t = /* @__PURE__ */ f(m, { ...o, children: e }), r[3] = e, r[4] = o, r[5] = t) : t = r[5], t;
}
export {
  a as Tab
};
